<template>
<div class="form">
<a-card title="编辑">
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        
        <a-form-model :model="modalState" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-form-model-item label="告警名称" prop="alertname" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.alertname" type="textarea" />
            </a-form-model-item>

            <a-form-model-item label="告警消息" prop="msg" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.msg" type="textarea" />
            </a-form-model-item>
             <a-form-model-item label="接收人" prop="receivername" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.receivername" type="textarea" />
            </a-form-model-item>
            <a-form-model-item label="推送通道" prop="channel" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.channel" type="textarea" />
            </a-form-model-item>
            <a-form-model-item label="手机号" prop="telephone" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.telephone" type="textarea" />
            </a-form-model-item>
            <a-form-model-item label="邮箱" prop="email" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.email" type="textarea" />
            </a-form-model-item>
            <a-form-model-item label="钉钉群" prop="dingdingname" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.dingdingname" type="textarea" />
            </a-form-model-item>

            <a-form-model-item label="发送时间" prop="createtime" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="modalState.createtime" type="textarea" />
            </a-form-model-item>

            <a-form-model-item   :wrapper-col="{ span: 14, offset: 10 }" >
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    返回
                </a-button>
            </a-form-model-item>

        </a-form-model>
 </a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";

export default {
    
    data() {
        return {
            is_vue_task : false,
            is_show:false,
            labelCol: {span: 3},
            wrapperCol: {span: 14},
            rules: {
                name: [
                    {required: true, message: '请输入钉钉群名', trigger: 'blur'},
                    {max: 50, message: '不能超过50位', trigger: 'blur'},
                ],
                url: [
                    {required: true, message: '请输入钉钉群地址', trigger: 'blur'},
                    {max: 100, message: '不能超过100位', trigger: 'blur'},
                ],
            },
            modalState:{
                id:'',
                alertname:'',
                alertmsg:'',
                receivers:'',
                receivername:'',
                channel:'',
                dingdingid:'',
                dingdingname:'',
                dingdingurl:'',
                createtime:'',
                createuser:'',
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            dingdinglist:[],
            tLoading1:false,
            actiontype:'',
            userlist:[],
            usercodes:[],
            checkedList: [],
        };
    },
    computed: {
        ...mapState("alarmconfig", {
            record: function(state) {
                return this.actiontype == "alertconfigadd" ? {
                    dingdingname: ''
                } : state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.confirmLoading = true;
            
            //编辑
            this.record.id = this.record.id;
            this.$store
                .dispatch({
                    type: "alarmconfig/alertconfigedit",
                    params: this.modalState
                })
                .then((response) => {
                    if(response.data.success == '1'){
                        console.log(response)
                        this.handleCancel();
                        this.confirmLoading = false;
                    }
                });
            
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        const {query, params} = this.$route;
        this.is_vue_task = true;
        this.actiontype=params.action;
        this.$store.dispatch({
            type: "alarmconfig/alerthistorydetails",
            params: query,
            showMsg: false
        }).then((res)=>{
            this.modalState = res.data.data;
        });
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
</style>
